import React, { useEffect } from "react";
import { Page, Frame, AppProvider } from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { Route, Switch } from "react-router-dom";
import Menu from "./Menu";
import routes from "../routes";
import { Spinner } from "@shopify/polaris";

import { Container, Row, Col } from "reactstrap";

import Rating from "./Rating";

import { useSelector, useDispatch } from "react-redux";
import {
	actFetchShowLoadingPage,
	actFetchDataSettings,
	actFetchListPayPalAccounts,
	actFetchListStore,
} from "../actions/index";
import callApi from "../utils/apiCaller";
import config from "../config/config";
import YearlyModalEnahnce from "./feature/yearly/YearlyModalEnahnce";
import YearWrapActivator from "./feature/yearendwrap/YearWrapActivator";
import YearlyPlanModal from "./feature/yearly/YearlyPlanModal";
import WhatsappChat from "./WhatsappChat";

const ContentApps = (props) => {
	const dispatch = useDispatch();
	const showLoadingPage = useSelector((state) => state.showLoadingPage);

	useEffect(() => {
		getData();
		getListStoreIntegrate();
		getDataPaypayAccount();
	}, []);

	const getData = async () => {
		let params = {
			action: "getData",
		};
		callApi("get", params).then((res) => {
			dispatch(actFetchDataSettings(res.data.dataSettings));
		});
	};

	const getDataPaypayAccount = async () => {
		dispatch(actFetchShowLoadingPage(true));
		let params = {
			action: "getDataPaypayAccount",
		};
		callApi("get", params).then(async (res) => {
			dispatch(actFetchListPayPalAccounts(res.data.dataPaypalAccount));
			dispatch(actFetchShowLoadingPage(false));
			setTimeout(() => {
				if (
					typeof window.$crisp != undefined &&
					res.data.dataPaypalAccount.length === 0 &&
					window.$crisp != undefined
				) {
					setTimeout(() => {
						let params = {
							action: "getDataPaypayAccount",
						};
						callApi("get", params).then(async (res) => {
							if (res.data.dataPaypalAccount.length === 0) {
								window.$crisp.push([
									"set",
									"session:event",
									["synctrack-connect-account"],
								]);
							}
						});
					}, 120000);
				}
			}, 10000);
		});
	};

	const getListStoreIntegrate = async () => {
		let params = {
			action: "getListStoreIntegrate",
		};
		callApi("get", params).then(async (res) => {
			if (res.data.state === 1) {
				dispatch(actFetchListStore(res.data.listStore));
			}
		});
	};

	const showContentMenus = (routes) => {
		var result = null;

		if (routes.length > 0) {
			result = routes.map((route, index) => {
				return (
					<Route
						key={index}
						exact={route.exact}
						path={route.path}
						component={route.main}
					/>
				);
			});
		}
		return result;
	};

	return (
		<AppProvider
			i18n={en}
			theme={{
				colorScheme: "light",
			}}
		>
			<Container fluid>
				<Row>
					<Col xs="12" sm="12">
						<Frame topBar={<Menu />}>
							<Page fullWidth="true">
								<Switch>{showContentMenus(routes)}</Switch>
							</Page>
							{showLoadingPage ? (
								<div id="i_loading_page_2">
									<Spinner size="large" color="teal" />
								</div>
							) : null}
						</Frame>
					</Col>
				</Row>
				<Row>
					<Col xs="12" sm="12" className="pl-0">
						{config.platform !== "WOO_COMMERCE" ? (
							<div className="app-footer">
								<Rating />
								{/* <MoreApp /> */}
							</div>
						) : null}
					</Col>
				</Row>
				<WhatsappChat />
			</Container>
			{/* <YearlyModalEnahnce /> */}
			<YearlyPlanModal />
			{/* {config.platform !== "WOO_COMMERCE" && <YearWrapActivator />} */}
		</AppProvider>
	);
};

export default ContentApps;
